import { createFileRoute } from "@tanstack/react-router";
import { MemoryBrowsePage } from "@/components/memory/memory-browse-page";
import { viewUrlParams } from "@/components/views/views-data";
import { useWorkspaceRoot } from "@/lib/api";

/**
 * A workspace-attached view on the Data hub: `/{owner}/data/-/views/<key>`.
 * The host reads no query keys here, so the whole query string is the view's
 * params (`?region=emea`).
 */
export const Route = createFileRoute("/$owner/data/-/views/$viewKey")({
	loader: ({ context: { queryClient }, params }) => {
		void queryClient.prefetchQuery(
			useWorkspaceRoot.queryOptions(params.owner, { slug: params.owner }),
		);
	},
	validateSearch: viewUrlParams,
	component: DataViewPage,
});

function DataViewPage() {
	const { owner, viewKey } = Route.useParams();
	return (
		<MemoryBrowsePage ownerSlug={owner} create={false} viewKey={viewKey} />
	);
}
